/**
 * agendaTheme.js — FASE 0: Paleta, tipografía y variables para módulo Agenda
 * Referencia: 0257-Maqueta-Desconfundir-Usuario-Agenda
 * Estética: minimalista, clara
 * FASE 3.3: Paleta diseñada para contraste WCAG AA (texto normal ≥4.5:1, grande ≥3:1)
 */

// Paleta de colores — módulo Agenda (coherente con app, identidad clara)
export const agendaPalette = {
  primary: "#4f46e5",
  primaryLight: "#6366f1",
  secondary: "#059669",
  background: "#eef0ff",
  backgroundDark: "#111827",
  card: "#ffffff",
  cardDark: "#1f2937",
  border: "#e5e8f0",
  borderDark: "#374151",
  textPrimary: "#1f2937",
  textSecondary: "#6b7280",
  textLight: "#f9fafb",
  // Estados de citas
  pending: "#ed6c02",
  confirmed: "#2e7d32",
  completed: "#66bb6a",
  cancelled: "#d32f2f",
  // Acciones
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444"
};

// Tipografía — fuentes y tamaños
export const agendaTypography = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  h1: { fontSize: "1.75rem", fontWeight: 600 },
  h2: { fontSize: "1.5rem", fontWeight: 600 },
  h3: { fontSize: "1.25rem", fontWeight: 600 },
  h4: { fontSize: "1.125rem", fontWeight: 600 },
  body1: { fontSize: "1rem", fontWeight: 400 },
  body2: { fontSize: "0.875rem", fontWeight: 400 },
  caption: { fontSize: "0.75rem", fontWeight: 400 },
  button: { fontSize: "0.875rem", fontWeight: 600 }
};

// Espaciado (px o rem)
export const agendaSpacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48
};

// Radios de borde (px)
export const agendaShape = {
  borderRadius: 14,
  borderRadiusSm: 10,
  borderRadiusLg: 16
};

// Sombras (minimalistas)
export const agendaShadows = {
  card: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
  cardHover: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
  dropdown: "0 10px 15px -3px rgba(0, 0, 0, 0.1)"
};

// Exportar objeto unificado para uso en makeStyles
export default {
  palette: agendaPalette,
  typography: agendaTypography,
  spacing: agendaSpacing,
  shape: agendaShape,
  shadows: agendaShadows
};
